// extracted by mini-css-extract-plugin
export var big = "button-module--big--806c8";
export var grey = "button-module--grey--9cb57";
export var root = "button-module--root--84653";
export var small = "button-module--small--19e33";
export var white = "button-module--white--c2c71";